<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/first/inspection/pageWo"
			getKey="rows" :columns="columns" @selectionChange="selectionChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shengchangongdanhao')">
						<el-input v-model="yt.conditions.no"></el-input>
					</el-form-item>
					<el-form-item :label="$t('ERPgongdanhao')">
						<el-input v-model="yt.conditions.erpNo"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongdanzhuangtai')">
						<yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'"
							:ids.sync="yt.conditions.statusList">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear(params)">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
	import out_stock from '@@/pages/web/production_management/picking/out_stock'
	export default {
		name: 'web_qunlong_bind_first_order_wo_order_page_list',
		components: {
			out_stock
		},
		data() {
			return {
				list: [],
				currentWoId: null,
				selectedRows: null,
				params: {
          materialId: this.$attrs.wo.materialId,
          woNo: this.$attrs.wo.woNo
				},
				columns: [{
						label: "xuanze",
						type: "selection",
						align: "center",
						selectable: (row, index) => true,
						width: 130,
					},
					{
						label: 'shengchangongdanhao',
						prop: 'no',
						width: 250,
					}, {
						label: 'ERPgongdanhao',
						prop: 'erpNo',
						sort: 'string',
						width: 130,
					},
					{
						label: 'gongdanzhuangtai',
						type: 'tag',
						sort: 'string',
						prop: 'status',
						width: 130,
						tags: {
							1: {
								color: '#419FFF',
								text: this.$t('xinjian')
							},
							2: {
								color: '#419FFF',
								text: this.$t('fafang')
							},
							3: {
								color: '#67C23A',
								text: this.$t('shengchanzhong')
							},
							4: {
								color: '#F56C6C',
								text: this.$t('zanting')
							},
							5: {
								color: '#67C23A',
								text: this.$t('shougongxuwangong')
							},
							6: {
								color: '#67C23A',
								text: this.$t('wangong')
							},
							7: {
								color: '#909399',
								text: this.$t('guanbi')
							},
							8: {
								color: '#E6A23C',
								text: this.$t('yidiaobo')
							}
						},
					},
					{
						label: 'shebeimingcheng',
						prop: 'equipment.name',
						sort: 'string',
						width: 230,
					},
					{
						label: 'mujubianhao',
						prop: 'mould.no',
						sort: 'string',
						width: 230,
					}, {
						label: 'chanpinbianma',
						prop: 'material.code',
						sort: 'string',
						width: 230,
					}, {
						label: 'chanpinmingcheng',
						prop: 'material.name',
						sort: 'string',
						width: 230,
					},
					{
						label: 'jihuashuliang',
						prop: 'planQuantity',
						sort: 'number',
						width: 130,
					},
					{
						label: 'baogongshuliang',
						prop: 'productionQuantity',
						width: 130,
					},
					{
						label: 'yibaogongliangpinshu',
						prop: 'finishGoodQuantity',
						width: 130,
					},
					{
						label: 'yibaogongbuliangpinshu',
						prop: 'finishBadQuantity',
						width: 130,
					},
					{
						label: 'shengyushengchanshuliang',
						prop: 'leftProductionQuantity',
						width: 130,
					}
				],
			};
		},
		created() {
			setTimeout(() => {
				console.log("attrs:", this.$attrs.wo)
				this.yt.conditions = {
					materialId: this.$attrs.wo.materialId,
          woNo: this.$attrs.wo.woNo
				};
				this.yt.get(1);
			}, 300)

		},
		methods: {
			// selectionChange(rows) {
			// 	console.log('rows',rows)
			//     if (rows.length > 0) {
			//       // 取消之前选中的行
			//       if (this.selectedRows) {
			// 		this.yt.$refs.table.toggleRowSelection(this.selectedRows,false);
			//       }
			//       // 设置当前选中的行
			//       this.selectedRows = rows[0];
			//     } else {
			//       this.selectedRows = null;
			//     }
			// 	console.log('sss',this.selectedRows)
			//   },
			selectionChange(rows) {
				console.log('rows:', rows)
				// 取消之前选中的行
				if (rows.length == 2) {
					this.yt.$refs.table.toggleRowSelection(rows[0], false);
					this.selectedRows = rows[1];
				} else if (rows.length == 1) {

					this.selectedRows = rows[0];
				} else if (rows.length == 0) {

					this.selectedRows = null;
				}

			},
		}

	}
</script>